<script setup>
import Button from 'dashboard/components-next/button/Button.vue';

const props = defineProps({
  product: {
    type: Object,
    required: true,
  },
  currency: {
    type: String,
    default: 'BRL',
  },
});

const emit = defineEmits(['remove']);

const formatCurrency = amount => {
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: props.currency || 'BRL',
  }).format(amount);
};

const thumbUrl = url => {
  if (!url) return url;
  return url.includes('?') ? `${url}&width=80` : url;
};

const label = () => {
  const parts = [props.product.title];
  if (props.product.variantTitle) parts.push(props.product.variantTitle);
  return parts.join(' — ');
};
</script>

<template>
  <div class="flex items-center p-1 bg-n-slate-3 gap-1 rounded-md w-[15rem]">
    <div class="max-w-[4rem] flex-shrink-0 w-6 flex items-center">
      <img
        v-if="product.imageUrl"
        class="object-cover w-6 h-6 rounded-sm"
        :src="thumbUrl(product.imageUrl)"
      />
      <span v-else class="i-lucide-package w-6 h-6 text-sm text-n-slate-10" />
    </div>
    <div class="max-w-3/5 min-w-[50%] overflow-hidden text-ellipsis">
      <span
        class="h-4 overflow-hidden text-sm font-medium text-ellipsis whitespace-nowrap block"
      >
        {{ label() }}
      </span>
    </div>
    <div class="w-[30%] justify-center">
      <span class="overflow-hidden text-xs text-ellipsis whitespace-nowrap">
        {{ formatCurrency(product.price) }}
      </span>
    </div>
    <div class="flex items-center justify-center">
      <Button
        ghost
        slate
        xs
        icon="i-lucide-x"
        @click="emit('remove')"
      />
    </div>
  </div>
</template>
